// Goleta-specific schema for commercial painting SEO optimization

export const getGoletaCommercialPaintingSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "PaintingContractor",
    "@id": "https://danispainting.net/service/commercial-painting/goleta#organization",
    "name": "Danis Painting Co. - Goleta Commercial Painting",
    "alternateName": "Goleta Commercial Painter",
    "url": "https://danispainting.net/service/commercial-painting/goleta",
    "logo": "https://danispainting.net/logo.png",
    "image": "https://danispainting.net/logo.png",
    "description": "Goleta's premier commercial painting contractor serving UCSB campus, Camino Real Marketplace, Santa Barbara Airport area, and Old Town Goleta. 30+ years experience with offices, retail stores, restaurants, warehouses, and student housing properties.",
    "telephone": "+1-805-403-8727",
    "email": "danispainting@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "133 E De La Guerra St, #267",
      "addressLocality": "Santa Barbara",
      "addressRegion": "CA",
      "postalCode": "93101",
      "addressCountry": "US"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "34.4358",
      "longitude": "-119.8276"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
        "opens": "00:00",
        "closes": "23:59"
      }
    ],
    "priceRange": "$$",
    "paymentAccepted": ["Cash", "Check", "Credit Card", "Debit Card", "Visa", "Mastercard", "American Express"],
    "areaServed": [
      {
        "@type": "City",
        "name": "Goleta",
        "@id": "https://en.wikipedia.org/wiki/Goleta,_California",
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "34.4358",
          "longitude": "-119.8276"
        }
      },
      {
        "@type": "Place",
        "name": "UCSB Campus",
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "34.4140",
          "longitude": "-119.8489"
        }
      },
      {
        "@type": "Place",
        "name": "Camino Real Marketplace",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "7004 Marketplace Drive",
          "addressLocality": "Goleta",
          "addressRegion": "CA",
          "postalCode": "93117"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "34.4397",
          "longitude": "-119.8284"
        }
      },
      {
        "@type": "Place",
        "name": "Santa Barbara Airport",
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "34.4262",
          "longitude": "-119.8403"
        }
      },
      {
        "@type": "Place",
        "name": "Old Town Goleta"
      },
      {
        "@type": "Place",
        "name": "Isla Vista"
      }
    ],
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Commercial Painting Services in Goleta",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Office Painting Goleta",
            "description": "Professional office painting for Goleta businesses near Camino Real Marketplace, Airport District, and UCSB. Evening and weekend scheduling available.",
            "provider": {
              "@type": "PaintingContractor",
              "name": "Danis Painting Co."
            },
            "areaServed": "Goleta, CA",
            "serviceType": "Commercial Office Painting"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Retail Store Painting Goleta",
            "description": "Commercial painting for retail businesses at Camino Real Marketplace including Costco, Home Depot area stores and Old Town Goleta shops.",
            "provider": {
              "@type": "PaintingContractor",
              "name": "Danis Painting Co."
            },
            "areaServed": "Goleta, CA",
            "serviceType": "Retail Commercial Painting"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Restaurant Painting Goleta",
            "description": "Professional restaurant painting services for Camino Real Marketplace dining establishments and Goleta restaurants. Health code compliant finishes.",
            "provider": {
              "@type": "PaintingContractor",
              "name": "Danis Painting Co."
            },
            "areaServed": "Goleta, CA",
            "serviceType": "Restaurant Commercial Painting"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Student Housing Painting Goleta",
            "description": "Apartment and student housing painting near UCSB. Work with Dean Brunner Rentals, St. George & Associates property managers.",
            "provider": {
              "@type": "PaintingContractor",
              "name": "Danis Painting Co."
            },
            "areaServed": "Goleta, CA",
            "serviceType": "Student Housing Painting"
          }
        },
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": "Warehouse Painting Goleta",
            "description": "Industrial and warehouse painting services for Goleta businesses. Epoxy floor coatings, industrial finishes.",
            "provider": {
              "@type": "PaintingContractor",
              "name": "Danis Painting Co."
            },
            "areaServed": "Goleta, CA",
            "serviceType": "Industrial Warehouse Painting"
          }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "24",
      "bestRating": "5",
      "worstRating": "1"
    },
    "founder": {
      "@type": "Person",
      "name": "Mark Danis"
    },
    "foundingDate": "1995",
    "slogan": "Honest New England Quality",
    "knowsAbout": [
      "Commercial Painting Goleta",
      "UCSB Campus Painting",
      "Camino Real Marketplace Painting",
      "Office Painting",
      "Retail Store Painting",
      "Restaurant Painting",
      "Student Housing Painting",
      "Warehouse Painting",
      "Property Management Painting"
    ],
    "sameAs": [
      "https://www.facebook.com/61568678263513",
      "https://www.yelp.com/biz/danis-painting-santa-barbara-4"
    ]
  };
};
